import React from "react";

export default function Contact() {
  return (
    <div className="rts-appoinment-area rts-section-gapTop rts-section-gapBottom" id="Contact">
      
      <div className="container">
        
        <div className="row">
          {/* Left Image */}

           <h2 style={{ textAlign: "center", marginBottom: "100px" , marginTop: "0px" , textDecoration: "underline" }}>Contact Us</h2>
          <div className="col-lg-6">
            <div className="thumbnail-area-appoinment">
              <img
                src="assets/images/appoinment/contact.png"
                alt="appoinment"
                style={{ width: "100%", borderRadius: "5px" }}
              />
            </div>
          </div>

          {/* Right Content */}
          <div className="col-lg-6 pl--60 pl_md--10 pl_sm--10 mt_md--50 mt_sm--50">
            <div className="appoinment-area-six-wrapper">
             
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d582.345519014865!2d79.83259290116294!3d10.922667511583766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a551136fcd05c4d%3A0x2e8fae39c8bd15b7!2sKaraikal%2C+Puducherry!5e0!3m2!1sen!2sin!4v1558686097196!5m2!1sen!2sin"
                width="100%"
                height="390"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                title="Cauvery Tours Map"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
